var map = {
	"./DIBS_shop_vertical_DK_10.png": 1992,
	"./DIBS_shop_vertical_EN_10.png": 2942,
	"./DIBS_shop_vertical_NO_10.png": 4398,
	"./DIBS_shop_vertical_SE_10.png": 7333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;